"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationMobileB2B = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../space/index");
var _kDsFoundation = _interopRequireDefault(require("../../lib/k-ds-foundation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LeftArrow = function LeftArrow(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m10.828 12 4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414-4.95 4.95Z",
    fill: "#888EA0"
  }));
};
LeftArrow.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var RightArrow = function RightArrow(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m13.172 12-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414 4.95-4.95Z",
    fill: "#18223D"
  }));
};
RightArrow.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ButtonArrow = /*#__PURE__*/_styledComponents["default"].button.withConfig({
  componentId: "kds-v1__sc-3b2psa-0"
})(["display:flex;align-items:center;justify-content:center;border:0;", " background:transparent;cursor:pointer;", " &:hover{", " svg path{", "}}", ""], _kDsFoundation["default"].setSpacingWithFallback('padding: ', 'spacing-04', 'spacing-04', 'spacing-04', 'spacing-04'), _kDsFoundation["default"].setTypographyWithFallback({
  'font-family': 'font-secondary',
  'font-weight': 'font-medium',
  'font-size': 'text-sm',
  'letter-spacing': 'tracking-wide',
  'line-height': 'snug'
}), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'interactive-primary-hover'), _kDsFoundation["default"].setColorTokenWithFallback('fill: ', 'interactive-primary-hover'), function (props) {
  return props.isInactive && (0, _styledComponents.css)(["", " svg path{", "}"], _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'interactive-alternate'), _kDsFoundation["default"].setColorTokenWithFallback('fill: ', 'interactive-alternate'));
});
var PaginationMobileB2B = exports.PaginationMobileB2B = function PaginationMobileB2B(props) {
  // Require maxiVisibleNumbers to be 5 or greater (due to fixed first, last and '...' elements)
  var totalPages = props.totalPages,
    totalElements = props.totalElements,
    currentPage = props.currentPage,
    changePage = props.changePage,
    elementsPerPage = props.elementsPerPage,
    className = props.className;
  if (totalPages === 1) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, " ");
  function prevPage() {
    if (currentPage > 1) changePage(currentPage - 1);
  }
  function nextPage() {
    if (currentPage < totalPages) changePage(currentPage + 1);
  }
  var currentPageFirst = (currentPage - 1) * elementsPerPage + 1;
  var currentPageLast = currentPageFirst + elementsPerPage - 1;
  if (currentPageLast > totalElements) currentPageLast = totalElements;
  var leftArrowInactive = currentPage === 1;
  var rightArrowInactive = currentPage === totalPages;
  return /*#__PURE__*/_react["default"].createElement(_index.Space, {
    direction: "horizontal",
    size: "medium",
    align: "center",
    className: className
  }, /*#__PURE__*/_react["default"].createElement(ButtonArrow, {
    type: "button",
    onClick: function onClick() {
      return prevPage();
    },
    isInactive: leftArrowInactive,
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement(LeftArrow, null)), /*#__PURE__*/_react["default"].createElement("span", {
    className: "k-ds-heading-01 k-ds-text-color-primary"
  }, "".concat(currentPageFirst, "-").concat(currentPageLast, " de ").concat(totalElements)), /*#__PURE__*/_react["default"].createElement(ButtonArrow, {
    type: "button",
    onClick: function onClick() {
      return nextPage();
    },
    isInactive: rightArrowInactive,
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement(RightArrow, null)));
};